<ion-content>
    <div class="cmn-wrapper">
        <app-sos></app-sos>
        <div class="cmn-navmenu-title cmn-text-shadow">Journal</div>
        <app-bubble [item]="bubbleProps"></app-bubble>
    </div>
   
</ion-content>